import { render, staticRenderFns } from "./inactive-table.vue?vue&type=template&id=3060f8e0"
import script from "./inactive-table.vue?vue&type=script&lang=js"
export * from "./inactive-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports